import UniqueId from './UniqueId'

export default UniqueId
// eslint-disable-next-line import/export
export * from './UniqueId'
